// Seeded randomness for creatures and habitats (same algorithms as the desktop app; the
// implementations live in @eb/shared).
import { hashString } from "@eb/shared";

export { hashString, mulberry32, Rng } from "@eb/shared";

/** Creature seed for a sound slot: scene key + slot, so the same slot always shows the same creature. */
export function creatureSeed(sceneId: string, slot: number): number {
  return hashString(`${sceneId}#pad${slot}`);
}
